// extracted by mini-css-extract-plugin
export default {"container":"SeparaterLabel_container__PhX9Y"};